export default __webpack_public_path__ + "static/media/banner4.d299f1cc.jpg";